import React from 'react';

const IconLeftArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16">
    <path fill="none" stroke="#33323D" d="M9 0L1 8l8 8" />
  </svg>
);

export default IconLeftArrow;
